import React, { useRef } from "react";
import { AppBasicTable, AppStartHint, searchStartHintProps, AppResultsSkeleton } from "@components";
import { useEuropcarPricingEnvTableData } from "../@hooks";
import {Grid, useTheme} from "@mui/material";
import { officeColumn, pricesColumn } from "./columns";
import { datesHeader, officeProvidersHeader } from "./headers";
import PricingEnvironmentTableTitle from "./Title";
import {formatDate, postExcel} from "@ui-seeker/utils";
import {BACKEND_APIS} from "@constants";
import {europcarPricingEnvFilters} from "../@signals";
import {rentalDates} from "../../../../../@signals";


export default function EuropcarPricingEnvironmentTable({ showStartHint = true }) {

    const { isLoading, tableHeaders, tableData, tableSubHeaders, providers } = useEuropcarPricingEnvTableData()
    // Only before the first search; after an empty one the page stays empty as it always did.
    const hasSearched = useRef(false)
    if (isLoading) hasSearched.current = true
    const { palette} = useTheme()

    if (isLoading) return <Grid item xs={12}><AppResultsSkeleton columns={8}/></Grid>
    if(!tableData?.length) return showStartHint && !hasSearched.current
        ? <Grid item xs={12}><AppStartHint {...searchStartHintProps}/></Grid>
        : null

    return <Grid item xs={12}>
            <AppBasicTable
                onDownload={() => postExcel(`${BACKEND_APIS.DASHBOARD}/excel`, { ...europcarPricingEnvFilters.value, pickupDate: rentalDates.value.map(date => formatDate(date, { format: 'yyyyMMdd' })) })}
                toolbarProps={{ actions: false }}
                titleProps={{ actions: false }}
                data={groupByBranch(tableData, providers, tableHeaders)}
                headers={[[officeProvidersHeader(), ...tableHeaders.map(header => datesHeader(header, tableSubHeaders))]]}
                columns={[
                    officeColumn(), ...tableHeaders.map((date, idx) => pricesColumn(date, tableSubHeaders, palette, idx, tableHeaders.length))
                ]}
                Components={{
                    Title: () => <PricingEnvironmentTableTitle />
                }}
            />
        </Grid>
}

// One grey row per branch and one row per provider under it, each with that provider's weeks per date.
function groupByBranch(rows, providers, dates) {
    return rows.flatMap(row => [
        { isBranch: true, name: row.name },
        ...providers.map(provider => ({
            name: provider,
            ...Object.fromEntries(dates.map(date => [date, row[date]?.[provider]])),
        })),
    ])
}